import React from 'react';
import { CrossIconvector, GreenTickAnimatedIcon, MailIcon, MessageIcon } from 'assets/icons';
import { CustomButton } from 'components';
import { formatAmount } from 'utils/amountUtils';
import { ButtonType } from 'components/custom-button/CustomButton';

interface RecordPaymentSuccessProps {
  isRootState: boolean;
  handleSidePanelBack: () => void;
  recordedAmount: number;
  onShareReceipt: () => void;
  handleCancelShareInvoice: () => void;
}

const RecordPaymentSuccess: React.FC<RecordPaymentSuccessProps> = ({
  handleSidePanelBack,
  recordedAmount,
  onShareReceipt,
  handleCancelShareInvoice
}) => {
  return (
    <div className="flex h-full flex-1 flex-col">
      <div className="flex flex-row items-center p-4">
        <div id="record-payment-success-close-button" onClick={handleSidePanelBack} className="cursor-pointer">
          <CrossIconvector className="shrink-0" />
        </div>
      </div>
      <div className="flex h-[calc(100%-40px)] flex-col px-4 pb-6">
        <div className="flex flex-1 flex-col items-center justify-center">
          <GreenTickAnimatedIcon />
          <div className={'mt-3 text-17px font-semibold text-successHighlight'}>Payment recorded successfully</div>
          <div className={'mt-2 text-3xl font-bold text-primaryText'}>${formatAmount(recordedAmount)}</div>
        </div>

        <div className="space-y-3">
          <div className={'mb-3 text-center text-xl font-bold text-primaryText'}>
            How would you like to share receipt?
          </div>

          <CustomButton
            id="record-payment-share-text-message"
            className="path-stroke-current min-h-12
              w-full py-2"
            childrenContainerStyles="text-17px"
            startIconStyle="mt-0.5"
            StartIcon={MessageIcon}
            onClick={() => onShareReceipt()}>
            Text message
          </CustomButton>

          <CustomButton
            id="record-payment-share-email"
            className="path-stroke-current min-h-12
              w-full py-2"
            childrenContainerStyles="text-17px"
            StartIcon={MailIcon}
            onClick={() => onShareReceipt()}>
            Email
          </CustomButton>
          <CustomButton
            id="record-payment-skip-sharing"
            type={ButtonType.SECONDARY}
            childrenContainerStyles="text-17px"
            className="path-stroke-current min-h-12 w-full py-2"
            onClick={handleCancelShareInvoice}>
            Skip sharing
          </CustomButton>
        </div>
      </div>
    </div>
  );
};

export default RecordPaymentSuccess;
